module.exports = __webpack_public_path__ + "img/search-icon.8f481c1c.png";